/* eslint-disable react/jsx-no-target-blank */
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuTraining() {
  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Quản lý đào tạo</span>
        </div>
      </div>

      <AsideMenuItem
        to='/training-management'
        // icon='/media/icons/duotune/general/gen019.svg'
        icon='/media/svg/custom/icn_location.svg'
        title='Quản lý đào tạo'
        fontIcon='bi-layers'
      />

      <AsideMenuItem
        to='/notification-management'
        // icon='/media/icons/duotune/general/gen019.svg'
        icon='/media/svg/custom/icn_location.svg'
        title='Quản lý thông báo'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
    </>
  )
}
